import React from "react";
import LivePrices from "../pages/LivePrices";
import Features from "../components/Features";
import AltinSlider from "../components/AltinSlider";
import Aratext from "../components/aratext";
import Aragovde from "../components/aragovde";
import Reveal from "../components/Reveal";

const Home: React.FC = () => {
  return (
    <div>
      <Reveal variant="fade-up" duration={700}>
        <LivePrices />
      </Reveal>
      <Reveal variant="fade-up" duration={700}>
        <Aratext />
      </Reveal>
      <Reveal variant="fade-up" duration={700}>
        <Aragovde />
      </Reveal>
      <Reveal variant="fade-up" duration={700}>
        <AltinSlider />
      </Reveal>
    </div>
  );
};

export default Home;
